import React, {useEffect, useState} from "react";
import {mrbgStore, redFldToWhite} from './mrbgRedux';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';

function MrbgCaptcha({formID,name,other,formStyle}){

  const
    [redFld,setRedFld] = useState( mrbgStore.getState().formsSettings[formID]?.redFld ),
    [img,setImg] = useState( mrbgStore.getState().mrbgVars.mrbgCaptchaImg ),
    [curVal,setCurVal] = useState('');

  function changeImg(){
    mrbgS2S(null, null, 'NCI', 'mrbgCI');
  }
  function changeValue(input){
    if( input.value!=='' ){
      mrbgStore.dispatch(redFldToWhite({formID,name}));
      setCurVal(input)
    }
  }

  useEffect(()=>{
    const unsubscribe = mrbgStore.subscribe(()=>{
      setRedFld( mrbgStore.getState().formsSettings[formID]?.redFld );
      setImg   ( mrbgStore.getState().mrbgVars.mrbgCaptchaImg      );
    })
    return () =>unsubscribe();
  },[]);
  useEffect(()=>{},[curVal])

  return(
    <>
      {img? <img className={formStyle.mrbgCaptchaImg} src={img}/>: ''}
      <input type="text" name={name} {...other} className={redFld?.includes(name)? formStyle.emptyField: ''} onChange={e=>changeValue(e.target.value)} key={formID=='signIn'?'si':'su'}/>
      <i className={`${formStyle.mrbgRecaptcha} fa-regular fa-refresh`} onClick={()=>changeImg()}></i>
    </>
  )
}

export default MrbgCaptcha;